var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main allergens-page"},[_c('section',[_c('div',{staticClass:"container"},[_c('h1',{staticStyle:{"font-size":"2.625rem"}},[_vm._v(" Cookie policy ")]),_c('div',{ref:"consent"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }